import script from "./SecurityPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecurityPanel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__